<template>
  <div>
    <v-form v-on:submit.prevent="send">
      <v-text-field
        :rules="rules"
        :error="errdesc.length > 0"
        :error-messages="errdesc"
        outlined
        autofocus
        required
        style="text-align: center"
        label="Телефон"
        v-mask="'+7(9##) ###-##-##'"
        v-model="phone"
        name="phone"
        type="text"
        @input="clearErrdesc"
      ></v-text-field>
      <v-checkbox color="#88BD1F" required v-model="checkbox" v-if="module === 'registration'">
        <template v-slot:label>
          <div class="font">
            Я соглашаюсь с
            <a class="text-link" @click.stop.prevent="showModal = true" href="#">условиями</a>
            обработки и использования моих персональных данных
          </div>
        </template>
      </v-checkbox>
    </v-form>
    <v-btn :disabled="disabled" x-large block color="primary" @click="send">{{ buttonLabel }}</v-btn>

    <v-dialog scrollable max-width="800" v-model="showModal">
      <v-card light style="padding: 12px">
        <v-card-title flat>
          <v-toolbar-title>Соглашение</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          {{ text }}
          <ul>
            <li>
              {{ textOne }}
            </li>
            <li>
              {{ textTwo }}
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    module: {
      type: String,
      default: "registration",
    },
  },
  computed: {
    ...mapGetters("common", ["errdesc"]),
    buttonLabel() {
      return this.module === "registration" ? "стать партнёром" : "восстановить пароль";
    },
    isAccept() {
      return this.module === "registration" ? this.checkbox : true;
    },
    phone: {
      get() {
        return this.$store.state[this.module].phone;
      },
      set(value) {
        this.$store.commit(this.module + "/setPhone", value);
      },
    },
    isPhone() {
      return /^\d{11}$/.test(this.phone.replace(/\D/g, ""));
    },
    disabled() {
      return !this.isAccept || !this.isPhone;
    },
  },

  data() {
    return {
      rules: [(v) => !!v || "Введите номер телефона", () => this.isPhone || "Введите номер телефона"],
      checkbox: true,
      showModal: false,
      text: `Я даю согласие ООО «МодульПартнер» ОГРН 1217700202015, ИНН 9715400317, адрес местонахождения 127015, город Москва, улица Новодмитровская, дом 2, корпус 1, пом. XXXV (далее – МодульПартнер):`,
      textOne: `на проведение проверки, в том числе с использованием услуг других операторов, достоверности предоставленных мной сведений, получение информации о неисполнении и/или ненадлежащим исполнении договорных обязательств;`,
      textTwo: `на обработку, как с использованием средств автоматизации, так и без использования таких средств, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование, извлечение, блокирование, удаление, уничтожение, а также передачу его Партнерам (АО КБ  «Модульбанк» (адрес местонахождения: 156005, г. Кострома, пл. Октябрьская, д.1), ООО «Аванпост» (адрес местонахождения 127015, город Москва, улица Новодмитровская, дом 2, корпус 1, пом. XXXV, офис 12) с правом Партнеров на обработку без получения дополнительного согласия следующих персональных данных, предоставленных мной лично при заполнении Анкеты или поступивших в Модульпартнер иными законными способами в целях заключения и исполнения любых договоров, проверки, в том числе с использованием услуг других операторов, достоверности предоставленных мной сведений, проверки информации о неисполнении и/или ненадлежащим исполнении договорных обязательств, информирования меня об изменениях в продуктах и услугах Модульпартнер и его Партнеров: фамилия, имя, отчество, данные документа, удостоверяющего личность, адрес регистрации, ИНН, фотографическое изображение, номер контактного телефона, адрес электронной почты. Согласие на обработку персональных данных действует с даты подписания до даты полного исполнения обязательств по договорам, в том числе, если в результате рассмотрения и обсуждения условий проектов договоров договорные отношения установлены не были, а также последующие 5 (пять) лет, в соответствии со сроками хранения документов, установленными законодательством Российской Федерации, и может быть отозвано путем направления письменного обращения в адрес Модульпартнер и/или его Партнеров в произвольной форме. В случае направления МодульПартнер персональных данных должностных лиц и/или работников гарантирую МодульПартнер, что получил от таких должностных лиц, работников согласия на передачу их персональных данных, а также обязуюсь возместить МодульПартнер ущерб, причиненный отсутствием такого согласия.`,
    };
  },
  methods: {
    ...mapActions("common", ["clearErrdesc"]),
    send() {
      if (this.isAccept && this.isPhone) {
        this.$store.dispatch(this.module + "/init");
      }
    },
  },
  destroyed() {
    this.clearErrdesc();
  },
};
</script>
